import axios from './BaseService';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export async function doLogin(email, password) {
    const loginUrl = `${API_URL}/login`;
    const response = await axios.post(loginUrl, { email, password });
    return response.data;
}

export async function doRegister(name, email, password) {
    const registerUrl = `${API_URL}/register`;
    const response = await axios.post(registerUrl, {name, email, password });
    return response.data;
}

export async function doLogout() {
    const logoutUrl = `${API_URL}/logout`;
    const response = await axios.post(logoutUrl, {});
    return response.data;
}

export async function getUserById(userId){
    const getUserByIdUrl = `${API_URL}/${userId}`;
    const response = await axios.get(getUserByIdUrl);
    return response.data;
}

// request a password reset (sends email with token from backend)
export async function requestPasswordReset(email) {
    const url = `${API_URL}/forgot-password`;
    const response = await axios.post(url, { email });
    return response.data;
}

// perform password reset using token delivered to user
export async function resetPassword(token, password) {
    const url = `${API_URL}/reset-password`;
    const response = await axios.post(url, { token, password });
    return response.data;
}